module.exports = __webpack_public_path__ + "static/media/blue_nebula_RT.7c65a090.png";